module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_44.60454899.jpg";